import { createContext } from 'react';
import { Resource } from 'i18next';
import { ButtonLayout } from '../../enums/ButtonLayout';
import { ViewMode } from '../../enums/ViewMode';
import { DetailPageViewMode } from '../../enums/DetailPageViewMode';
import { CondoListViewMode } from '../../enums/CondoListViewMode';
import { ImageViewMode } from '../../enums/ImageViewMode';

export type SettingsContextType = {
    basePath: string;
    redirectPath?: string;
    publicUrl: string;
    tokenUrl: string;
    apiUrl: string;
    recaptchaUrl: string;
    companyInfoId?: string;
    listViewMode: string;
    detailPageViewMode: string;
    locationViewMode: string;
    messageViewMode: string;
    imageViewMode: string;
    buttonLayout: string;
    sendFlowersUrl?: string;
    useGoogleRecaptchaV3: boolean;
    useGoogleRecaptchaV3Enterprise: boolean;
    googleRecaptchaV3PublicKey?: string;
    loadDefaultFont: boolean;
    openExternalLinksInSameWindow: boolean;
    birthIcon: string;
    deathIcon: string;
    condoFallbackImage: string;
    headerFallbackImage: string;
    locationFallbackImage: string;
    notFoundUrl: string;
    privacyPolicyUrl: string;
    locale: string;
    debugMode: boolean;
};

const SettingsContext = createContext<SettingsContextType>({
    basePath: '/',
    publicUrl: window.location.href,
    tokenUrl: '',
    apiUrl: '',
    recaptchaUrl: '',
    companyInfoId: '',
    listViewMode: CondoListViewMode.Contain,
    detailPageViewMode: DetailPageViewMode.Tabs,
    locationViewMode: ViewMode.GridView,
    messageViewMode: ViewMode.GridView,
    imageViewMode: ImageViewMode.Arched,
    buttonLayout: ButtonLayout.Wide,
    useGoogleRecaptchaV3: false,
    useGoogleRecaptchaV3Enterprise: false,
    loadDefaultFont: true,
    openExternalLinksInSameWindow: false,
    birthIcon: '',
    deathIcon: '',
    condoFallbackImage: '',
    headerFallbackImage: '',
    locationFallbackImage: '',
    notFoundUrl: '',
    privacyPolicyUrl: '',
    locale: '',
    debugMode: false,
});
export default SettingsContext;
